const guideGen72 = [
  "Starter auswählen & Hauholi City erreichen",
  "Route 1 – Erstes wildes Pokémon",
  "Route 2 – Pokémon fangen & erste Trainer",
  "Hauholi City – Pokémon-Schule & Prüfung",
  "Route 3 & Mele-Mele-Blumenmeer",
  "Verdant Cavern – Erste Inselprüfung (Normal)",
  "Route 5 & Brooklet Hill",
  "Brooklet Hill – Zweite Prüfung (Wasser)",
  "Wela Vulkanpark – Dritte Prüfung (Feuer)",
  "Royal Avenue & Kampfbus",
  "Route 8 & Fossilzentrum",
  "Lush Jungle – Vierte Prüfung (Pflanze)",
  "Konikoni City – Vorbereitung auf Inselkönig",
  "Ruinen des Lebens – Inselkönigin Hapu'u (Gestein)",
  "Akala verlassen – Ula-Ula Island erreichen",
  "Malie City & Route 10 – Kampfbaum",
  "Hokulani Observatorium – Prüfung (Elektro)",
  "Route 12 & 13",
  "Po Town – Team Skull aufhalten",
  "Aether Paradise – Story-Fortschritt",
  "Poni Island erreichen",
  "Poni Wildnis & Schluchten erkunden",
  "Große Prüfung gegen Inselkönigin Hapu'u (Boden)",
  "Alter Pfad & Megalithenpfad",
  "Mount Lanakila – Vorbereitung zur Pokémon-Liga",
  "Pokémon-Liga Alola – Top 4 & Champ",
];

export default guideGen72;